import { createSlice, createSelector } from "@reduxjs/toolkit";

import { moveMapTo } from "./mapSlice";
import { getTransports } from "./transportSlice";

const REDUCER_KEY = "filter";
export const FILTER_REDUCER_KEY = REDUCER_KEY;

const agent =
  !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

const slice = createSlice({
  name: REDUCER_KEY,
  initialState: {
    opened: agent,
    closing: agent,
    company: true,
    type: true,
  },
  reducers: {
    setFilterOpened: (state, { payload }) => {
      state.opened = payload;
    },
    setFilterClosing: (state, { payload }) => {
      state.closing = payload;
    },
    setCompanyFilter: (state, { payload }) => {
      state.company = payload;
    },
    setTypeFilter: (state, { payload }) => {
      state.type = payload;
    },
    moveMapToTransport: (state) => state,
  },
});

export const {
  setFilterOpened,
  setCompanyFilter,
  setTypeFilter,
  moveMapToTransport,
  setFilterClosing,
} = slice.actions;

export const SIDEBAR_CLASSNAME = "my-sidebar-classname";
export const filterMiddleware = (store) => (next) => (action) => {
  next(action);

  if (action.type === moveMapToTransport.type) {
    const state = store.getState();
    const goalTransportId = action.payload;
    const menuOpened = getFilterOpened(state);
    const transport = getTransports(state).filter(
      ({ id }) => id === goalTransportId
    )[0];

    if (transport) {
      const { lat, lng } = transport;
      const menuWidth = menuOpened
        ? document.querySelector(`.${SIDEBAR_CLASSNAME}`).offsetWidth
        : 0;
      const mapWidth = window.map.getSize().x;
      const isMenuBig = menuWidth > mapWidth / 2;

      if (!menuOpened || isMenuBig) {
        // Центрируем карту в центре экране
        store.dispatch(moveMapTo({ lat, lng, zoom: 18 }));
      } else {
        // Центрируем карту чуть правее, учитывая, что слево открытая менюшка
        // Дальше идут сложные вычисления, которые работают только для уже выбранного zoom=18 и ширины менюшки 299px
        // по этому я скалькулировал их один раз и записал себе, чтоб использовать, когда выбран любой zoom

        // const bounds = window.map.getBounds()
        // const mapLngDifference = bounds.getEast() - bounds.getWest()
        // const menuWidthPercents = menuWidth / mapWidth
        // const lngFinal = lng - mapLngDifference * menuWidthPercents / 2

        const LNG_SHIFT = 0.0008019804954521349;
        const lngFinal = lng - LNG_SHIFT;
        store.dispatch(
          moveMapTo({
            lat,
            lng: lngFinal,
            zoom: 18,
          })
        );
      }

      if (isMenuBig) {
        store.dispatch(setFilterOpened(false));
      }
    }
  }
};

const getState = (state) => state[REDUCER_KEY];
export const getFilterOpened = (state) => getState(state).opened;
export const getFilterClosing = (state) => getState(state).closing;
export const getCompanyFilter = (state) => getState(state).company;
export const getTypeFilter = (state) => getState(state).type;

export const getAvailableCompanies = createSelector(
  getTransports,
  getTypeFilter,
  (transports, selectedTypes) => {
    const availableCompanies = {};

    if (selectedTypes === true) {
      transports.forEach(({ company }) => {
        availableCompanies[company] = true;
      });
    } else {
      transports.forEach(({ type, company }) => {
        if (selectedTypes.includes(type)) {
          availableCompanies[company] = true;
        }
      });
    }

    return Object.keys(availableCompanies);
  }
);

export const getAvailableTypes = createSelector(
  getTransports,
  getCompanyFilter,
  (transports, selectedCompanies) => {
    const availableTypes = {};

    if (selectedCompanies === true) {
      transports.forEach(({ type }) => {
        availableTypes[type] = true;
      });
    } else {
      transports.forEach(({ type, company }) => {
        if (selectedCompanies.includes(company)) {
          availableTypes[type] = true;
        }
      });
    }

    return Object.keys(availableTypes);
  }
);

export const getFilteredTransports = createSelector(
  getTransports,
  getCompanyFilter,
  getTypeFilter,
  (transports, selectedCompanies, selectedTypes) => {
    let transportsOut = [...transports];

    if (selectedCompanies !== true) {
      transportsOut = transportsOut.filter(({ company }) =>
        selectedCompanies.includes(company)
      );
    }

    if (selectedTypes !== true) {
      transportsOut = transportsOut.filter(({ type }) =>
        selectedTypes.includes(type)
      );
    }

    return transportsOut;
  }
);

export default slice.reducer;
